/**
 * Authentication的简写，用于身份鉴别，用于PaaS-SDK接口增加签名机制
 */
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import MD5 from 'crypto-js/md5';
import SHA256 from 'crypto-js/sha256';
import log from 'loglevel';
const sm3 = require('sm-crypto/dist/sm3');

let _sKey = '';
let _signType = 2; // 生成签名方式 0-MD5 2-SHA256 3-SM3，默认2
export const setSecretKey = function (val) {
  _sKey = val;
};

export const setSignType = function (val) {
  if (!isNaN(val)) {
    _signType = val;
  }
}

export const getSignType = function () {
  return _signType;
}

/**
 * 随机生成指定数量的16进制key
 * @param {number} num 指定数量，默认48
 * @returns
 */
export const generateKey = function (num = 48) {
  const library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let key = '';
  for (var i = 0; i < num; i++) {
    let randomPoz = Math.floor(Math.random() * library.length);
    key += library.substring(randomPoz, randomPoz + 1);
  }
  return key;
};

/**
 * rsa加密
 * @param {*} val 待加密数据
 */
export const encodeRSA = function (val, publicKey) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(val); // 对数据进行加密
};

/**
 * 生成签名
 * @param {*} secret_key
 * @param {Number} signType 生成签名方式 0-MD5 2-SHA256 3-SM3，默认2
 * @param {*} params
 * @returns
 */
export const generateSign = function (params, secretKey, signType) {
  if (!secretKey) secretKey = _sKey;
  if (!secretKey) {
    log.warn('secretKey is empty');
    return '';
  }
  if (isNaN(signType)) signType = _signType;
  if (Object.prototype.toString.call(params).toLowerCase() !== '[object object]') {
    params = {};
  }
  // ①按名称字段排序, ②按 键值键值 方式拼接成字符串。
  const newKeys = Object.keys(params).sort();
  let signParam = '';
  for (const k of newKeys) {
    signParam += `${k}${params[k]}`;
  }
  // ③在此字符串首尾各拼接一次secret_key
  const readyKeyStr = `${secretKey}${signParam}${secretKey}`;

  // ④ 对拼接后的字符串进行加密(sm3、sha256、md5），得到sign
  if (signType === 3) {
    return sm3(readyKeyStr).toString().toLocaleLowerCase();
  } else if (signType === 0) {
    return MD5(readyKeyStr).toString().toLocaleLowerCase();
  } else {
    return SHA256(readyKeyStr).toString().toLocaleLowerCase();
  }
};

/**
 * AES解密
 * @param data 需要解密的数据
 * @param key 密钥
 * @param iv 偏移量
 * @returns 解密后的数据
 */
export const decodeAES = function (data, key, iv) {
  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }
  // 默认 mode: CBC , padding: Pkcs7
  const result = AES.decrypt(data, Utf8.parse(key), {
    iv: Utf8.parse(iv)
  });
  // 转为utf-8编码
  return Utf8.stringify(result);
};
